(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-product-purchase-v2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pawgap-purchase')) {
customElements.define('pawgap-purchase', class extends HTMLElement {
connectedCallback() {
this.controller = new AbortController();
const signal = this.controller.signal;
const variantInput = this.querySelector('[data-pgp-variant-id]');
const radios = [...this.querySelectorAll('[data-height]')];
const update = value => {
const radio = radios.find(item => item.value === String(value));
if (!radio) return;
radios.forEach(item => item.checked = item === radio);
const price = radio.dataset.price;
const display = this.querySelector('.pgp-price');
if (display) display.textContent = price;
const buttonPrice = this.querySelector('.pgp-button-price');
if (buttonPrice) buttonPrice.textContent = price;
document.querySelectorAll('.pgp-sticky-price').forEach(item => item.textContent = price);
const button = this.querySelector('.pgp-main-add');
if (button) button.disabled = radio.dataset.available !== 'true';
const label = this.querySelector('.pgp-button-label');
if (label) label.textContent = radio.dataset.available === 'true' ? 'ADD TO CART' : 'SOLD OUT';
const url = new URL(location.href);
url.searchParams.set('variant', value);
history.replaceState({}, '', url);
};
this.addEventListener('change', event => {
if (event.target.matches('[data-height]')) {
variantInput.value = event.target.value;
variantInput.dispatchEvent(new Event('change', { bubbles: true }));
} else if (event.target === variantInput) update(variantInput.value);
}, { signal });
this.querySelectorAll('.pgp-thumb').forEach(button => button.addEventListener('click', () => {
const main = this.querySelector('#pgp-main-image');
if (main) { main.src = button.dataset.image; main.removeAttribute('srcset'); }
this.querySelectorAll('.pgp-thumb').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
}, { signal }));
document.addEventListener('click', event => {
if (event.target.closest('[data-pgp-scroll-to-buy]')) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
}, { signal });
}
disconnectedCallback() { this.controller?.abort(); }
});
}

  } catch(e) { console.error(e); }
})();
})();
